import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { formatCalendarDate } from '../utils';
import { isSameUser, isSameTimeRange } from '../utils/message';

import { LocaleContext } from 'context/LocaleContext';

import MessageRich from './message-rich';

const MESSAGE_GROUP_MINUTES_THRESHOLD = 2;

const GroupHolder = ({ noDivider, children }) => {
    if (noDivider) {
        return children;
    }

    return <div className="messages-group">{ children }</div>
}

export default class DiscussionDayGroup extends Component {
    static contextType = LocaleContext;

    static propTypes = {
        day: PropTypes.number,
        noDivider: PropTypes.bool,
        messages: PropTypes.array
    }

    isInRage(dateA, dateB) {
        return moment.duration(moment(dateA).diff(dateB)).asMinutes() <= MESSAGE_GROUP_MINUTES_THRESHOLD
    }

    groupMessages() {
        const groups = [];
        let previousMessage;

        this.props.messages.forEach(message => {
            if (message.loading) {
                return;
            }
            
            const merge = isSameUser(message, previousMessage) && isSameTimeRange(message, previousMessage) && (message.hidden || [])?.toString() === (previousMessage.hidden || [])?.toString();

            if (merge) {
                // Merge to last group
                groups[groups.length - 1].items.push(message);
            } else {
                // Create a new group
                groups.push({
                    id: message.author,
                    items: [message]
                });
            }

            previousMessage = message;
        });

        return groups;
    }

    shouldComponentUpdate(nextProps) {
        if (
            (this.props.day !== nextProps.day) ||
            (this.props.noDivider !== nextProps.noDivider) ||
            (this.props.messages !== nextProps.messages)
        ) return true;

        return false;
    }

    render() {
        const messageGroups = this.groupMessages();
        const groups = messageGroups.map((group, index) => (
            <GroupHolder key={index} noDivider={this.props.noDivider}>
                {
                    group.items.map((message, index) => (
                        <MessageRich
                            key={message.id || index}
                            id={message.id}
                            type={message.type}
                            text={message.text}
                            url={message.url}
                            docAttachment={message.doc_attachment}
                            attachments={message.attachments}
                            seenBy={message.seen_by}
                            pending={!message.id}
                            error={message.error}
                            system={Boolean(message.subtype || !message.author)}
                            systemMessageType={message.subtype}
                            systemMessageData={message.system_message_data || message.system_comment_data}
                            botName={message.bot_name}
                            botAvatar={message.bot_avatar}
                            edited={message.is_edited}
                            removed={message.is_deleted}
                            author={message.author}
                            createdAt={message.created_at}
                            replies={message.replies}
                            repliers={message.repliers}
                            reactions={message.reactions}
                            hidden={message.hidden}
                            fragment={message.fragment}
                        />
                    ))
                }
            </GroupHolder>
        ))

        if (this.props.noDivider) {
            return groups;
        }

        return (
            <div className="discusison-day-group">
                <div className="discussion-item-divider">
                    <span>
                        { formatCalendarDate(this.props.day, this.context) }
                    </span>
                </div>

                <div className="discusison-day-group-body">
                    { groups }
                </div>
            </div>
        )
    }
}
